import { One, OrderDirection } from '@granlupo/api-client/generated/content/zeus'
import clsx from 'clsx'
import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next'
import { useLocalizedSignIn } from '../hooks/useLocalizedSignIn'
import { serverPropsHandler } from '../libs/next/api/handlers'
import { websiteContent } from '../libs/next/loaders/graphql/src/contentClient'
import { BoxCard } from '../src/components/shared/BoxCard'
import { Button } from '../src/components/shared/Button'
import { Container } from '../src/components/shared/Container'
import { Layout } from '../src/components/shared/Layout'
import { InternalLink } from '../src/const/Links'
import { Translation, useTranslate } from '../src/contexts/TranslationContext'
import { LayoutFragment } from '../src/data/LayoutFragment'
import { RegisterClaimFragment } from '../src/data/RegisterClaimFragment'
import { SeoFragment } from '../src/data/SeoFragment'
import style from '../src/styles/LoginRegisterPage.module.sass'
import { SignUpform } from '../src/user/SignUpForm'

type GenericPageProps = InferGetServerSidePropsType<typeof getServerSideProps>

export default function GenericPage(props: GenericPageProps) {
	const translate = useTranslate()
	const { signIn } = useLocalizedSignIn()

	return (
		<Layout
			footer={props.data.footer.getFooter}
			hasBreadcrumbs
			socials={props.data.socials.listSocial}
			seo={props.data.getRegisterPage?.seo}
			url={InternalLink.Register}
		>
			<div className={style.container}>
				<Container size="narrow">
					<div className={style.wrapper}>
						<h1 className={style.title}>
							<Translation tr="register.title" />
						</h1>
						<div className={style.cardGroup}>
							{props.data.listRegisterClaim.map((card) => (
								<BoxCard key={card.id} text={card.text} />
							))}
						</div>
						<div className={style.content}>
							<SignUpform />
						</div>
						<h2 className={style.titleLogin}>
							<Translation tr="register.login.title" />
						</h2>
						<div className={clsx(style.buttonWrapper, style.loginWrapper)}>
							<Button
								label={translate('register.login.button')}
								onClick={() => signIn()}
								type={{ variant: 'bordered' }}
							/>
						</div>
					</div>
				</Container>
			</div>
		</Layout>
	)
}

// export const runtime = 'experimental-edge'
export const getServerSideProps = serverPropsHandler(async (context: GetServerSidePropsContext) => {
	context.res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate=3600')

	const content = websiteContent

	const data = await content('query')({
		...LayoutFragment(),
		listRegisterClaim: [{ orderBy: [{ order: OrderDirection.asc }] }, RegisterClaimFragment()],
		getRegisterPage: [{ by: { unique: One.One } }, { seo: [{}, SeoFragment()] }],
	})

	return {
		props: {
			data,
		},
	}
})
